/** @format */

import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    sm: 768,
    md: 1000,
    lg: 1280,
    xl: 1600,
    xxl: Infinity,
  },
})
